import { Button } from '@/components/ui/button'

const SortableHeader = ({ title, column }) => (
    <Button
        variant="ghost"
        onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        className="tw:h-auto tw:p-0 tw:font-semibold tw:hover:!bg-transparent"
    >
        {title}
    </Button>
)

export default SortableHeader
